import React, { Component } from 'react'
import { connect } from 'react-redux'
import { router } from 'router'
import { TweenMax, Power3, Expo } from 'gsap'

import fetch from 'cross-fetch'
import values from 'src/values'
import Scroller from 'src/utils/scroller'
import config from 'src/config'
import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import components from 'src/utils/components'

// COMPONENTS
import Player from './components/player'
import ScrollMore from './components/scroll-more'
import World from './components/world'
import Wall from './components/wall'
import Footer from './components/footer'
import Menu from './components/menu'
import MenuMobile from './components/menu-mobile'
import Header from './components/header'
import PlayerVideo from 'src/components/player'

import './styles.scss'

export default class Home extends Component {
  constructor(props) {
    super(props)

    this.key = `homePage`
    this.state = {
      insta: components.allComponents.insta
        ? components.allComponents.insta
        : [],
      isMobile: values.viewport.width < config.bp.md,
      ...this.props
    }
  }

  load() {
    return new Promise((resolve, reject) => {
      if (components.allComponents.insta) {
        resolve()
      } else {
        fetch(
          `https://www.juicer.io/api/feeds/theworldsofchaumet?per=100&page=1`
        )
          .then(response => response.json())
          .then(json => {
            components.saveComponent('insta', json.posts.items)

            this.setState({
              insta: json.posts.items
            })

            resolve()
          })
      }
    })
  }

  setComponent(component, params, route, localized, main) {
    this.setState({
      ...localized,
      ...main
    })
  }

  setupScroller() {
    Scroller.update({
      el: this.refs.pageContainer,
      params: {
        overflow: false,
        infinite: false
      }
    })
  }

  componentDidMount() {
    raf.add(this.onRAF)
    resize.add(this.onResize, this.key)
    this.onResize()

    components.saveComponent('homeMenu', this.refs.menu)
    components.saveComponent('homeWorld', this.refs.world)
    components.saveComponent('homeMenuMobile', this.refs.menuMobile)
    components.saveComponent('homePlayer', this.refs.player)
    components.saveComponent('home', this)
    components.saveComponent('footer', this.refs.footer)

    document.title = this.state.playerCover.title.replace('<br>', ' ')
  }

  componentDidUpdate() {
    document.title = this.state.playerCover.title.replace('<br>', ' ')
  }

  willAnimateIn(previous) {
    return new Promise(resolve => {
      TweenMax.set(this.refs.pageContainer, { autoAlpha: 0 })

      previous != 'world' &&
        TweenMax.set(this.refs.blueOverlay, { autoAlpha: 0 })

      !this.state.isMobile && this.setupScroller()

      resolve()
    })
  }

  animateIn(previous, previousParams) {
    return new Promise(resolve => {
      if (previous === 'world') {
        if (this.state.isMobile) {
          let worldItem = 0

          this.state.worldDiscover.worlds.types.map((world, i) => {
            if (world.url === router.previousParam) {
              worldItem = i
            }
          })
          window.scrollTo(0, 0)
          window.scrollTo(
            0,
            this.refs.blockPlayer.hComponent +
              this.refs.scroll.hComponent +
              (worldItem + 1) * values.viewport.width -
              values.viewport.height / 2 +
              150
          )
        } else {
          Scroller.scrollTo(
            components.allComponents.homeWorld.topComponent - 70,
            0
          ).then()
        }

        TweenMax.fromTo(
          this.refs.pageContainer,
          1.2,
          { autoAlpha: 0 },
          {
            autoAlpha: 1,
            ease: Expo.easeOut
          }
        )
        TweenMax.fromTo(
          [
            this.refs.blockPlayer.refs.component,
            this.refs.scroll.refs.component,
            this.refs.world.refs.component
          ],
          2,
          { x: -200 },
          { x: 0, ease: Expo.easeOut }
        )
        TweenMax.fromTo(
          this.refs.blueOverlay,
          1,
          { x: '0%', autoAlpha: 1 },
          {
            x: '100%',
            ease: Expo.easeOut,
            onComplete: () => {
              TweenMax.set(this.refs.blueOverlay, { autoAlpha: 0 })
              resolve()
            }
          }
        )
      } else {
        TweenMax.staggerFromTo(
          [
            this.refs.blockPlayer.refs.component,
            this.refs.scroll.refs.component,
            this.refs.world.refs.component
          ],
          2,
          { y: 130 },
          { y: 0, ease: Expo.easeOut },
          0.15
        )
        TweenMax.fromTo(
          this.refs.pageContainer,
          2,
          { autoAlpha: 0 },
          {
            autoAlpha: 1,
            ease: Expo.easeOut,
            onComplete: () => {
              resolve()
            }
          }
        )
      }
    })
  }

  animateOut(next) {
    return new Promise(resolve => {
      if (next === 'world') {
        TweenMax.to(
          [
            this.refs.blockPlayer.refs.component,
            this.refs.scroll.refs.component,
            this.refs.world.refs.component
          ],
          0.5,
          { x: -200, ease: Expo.easeIn, delay: 0.2 }
        )
        TweenMax.fromTo(
          this.refs.blueOverlay,
          0.7,
          { x: '100%', autoAlpha: 1 },
          {
            x: '0%',
            ease: Expo.easeIn,
            onComplete: () => {
              resolve()
            }
          }
        )
      } else {
        TweenMax.to(this.refs.pageContainer, 2, {
          autoAlpha: 0,
          ease: Expo.easeOut,
          onComplete: () => {
            resolve()
          }
        })
      }
    })
  }

  onRAF = () => {
    if (!this.refs.pageContainer || this.state.isMobile) return

    const translate3d = `translate3d(0, ${-values.scroll.currentY}px, 0)`
    this.refs.pageContainer.style.transform = translate3d
    this.refs.pageContainer.style.webkitTransform = translate3d
    this.refs.pageContainer.style.mozTransform = translate3d
    this.refs.pageContainer.style.msTransform = translate3d
    this.refs.pageContainer.style.oTransform = translate3d

    !values.scroll.isntScrolling && this.weChatVisible && this.hideWeChat()
  }

  onResize = () => {
    if (!this.refs.pageContainer) return

    if (this.state.isMobile != values.viewport.width < config.bp.md) {
      this.setState({
        isMobile: values.viewport.width < config.bp.md
      })
    }
  }

  showWeChat() {
    this.weChatVisible = true
    TweenMax.set(this.refs.wechat, { autoAlpha: 1 })
  }

  hideWeChat() {
    console.log('here')
    this.weChatVisible = false
    TweenMax.set(this.refs.wechat, { autoAlpha: 0 })
  }

  onClick = () => {}

  render() {
    const {
      playerCover,
      scrollCta,
      worldDiscover,
      wall,
      footer,
      header,
      switcher,
      currentLanguage
    } = this.state

    const ctx = router.getContext()

    return (
      <div
        ref="page"
        onClick={this.onClick}
        className={`page home-page page-${ctx.locale}`}>
        <Header
          ref="header"
          {...header.back}
          switcher={switcher}
          currentLanguage={currentLanguage}
        />
        <span ref="blueOverlay" className="overlay-home in-out" />
        <div ref="pageContainer" className="main-content">
          <Player
            ref="blockPlayer"
            order={3}
            title={playerCover.title}
            content={playerCover.content}
            cover={playerCover.cover}
            idYt={playerCover.idYt}
            legend={playerCover.legend}
          />
          <ScrollMore ref="scroll" content={scrollCta} />
          <World
            ref="world"
            order={2}
            title={worldDiscover.title}
            content={worldDiscover.content}
            worlds={worldDiscover.worlds}
            cta={worldDiscover.worldCta}
            legend={worldDiscover.legend}
          />
          {this.state.insta.length > 0 && (
            <Wall
              order={1}
              title={wall.title}
              content={wall.content}
              previous={wall.previous}
              next={wall.next}
              cta={wall.cta}
              legend={wall.legend}
              data={this.state.insta}
            />
          )}
          <Footer
            ref="footer"
            order={0}
            title={footer.title}
            exposition={footer.exposition}
            museum={footer.museum}
            links={footer.links}
            legend={footer.legend}
          />
          <span className="btm-banner" />
        </div>
        <Menu ref="menu" />
        <MenuMobile
          worlds={worldDiscover.worlds.types}
          currentLanguage={currentLanguage}
          switcher={switcher}
          ref="menuMobile"
        />
        <PlayerVideo ref="player" idYt={playerCover.idYt} />

        <img
          ref="wechat"
          className="wechat-logo"
          onClick={this.hideWeChat}
          src={`${process.env.PUBLIC_URL}/img/social/qr-wechat.jpg`}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js